{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "traffic_control",
  "title": "Display Rules",
  "description": "When and where to show the widget: traffic percentage, mobile, URL patterns.",
  "type": "object",
  "properties": {
    "traffic_percentage": {
      "type": "integer",
      "ui:sectionTitle": "Traffic & Display",
      "ui:sectionDescription": "Who sees the widget, and how it appears.",
      "ui:sectionIcon": "Sun",
      "ui:widget": "percentage-slider",
      "ui:tooltip": "Percentage of visitors who see the widget.",
      "ui:description": "Drag the slider or type a value to control how many visitors see the chat widget. Lowering this below 100% means only the chosen share of visitors will see the widget.",
      "minimum": 0,
      "maximum": 100
    },
    "widget_display_mode": {
      "type": "string",
      "x-tier": "advanced",
      "enum": [
        "normal",
        "hidden_zone_click"
      ],
      "ui:description": "How widget appears: normal (always visible) or hidden_zone_click (click to reveal)"
    },
    "enable_mobile": {
      "type": "boolean",
      "ui:sectionTitle": "Device Targeting",
      "ui:sectionDescription": "How the widget behaves on mobile.",
      "ui:sectionIcon": "Smartphone",
      "ui:description": "Show widget on mobile devices"
    },
    "mobile_breakpoint": {
      "type": "integer",
      "ui:description": "Screen width below which is considered mobile",
      "x-access": "staff",
      "minimum": 100,
      "maximum": 2000
    },
    "display_only_on_urls": {
      "type": "array",
      "ui:sectionTitle": "URL Targeting",
      "ui:sectionDescription": "Where the widget is allowed to show.",
      "ui:sectionIcon": "Link2",
      "ui:title": "Display Only on URLs",
      "ui:tooltip": "Restrict the widget to specific URLs.",
      "ui:description": "If set, the widget only appears on these URLs. Per-page display rules can still override this allowlist. To match query params or hashes, include ? or # explicitly in the pattern.",
      "maxItems": 100,
      "items": {
        "type": "string"
      }
    },
    "page_display_rules": {
      "type": "array",
      "ui:tooltip": "Per-page widget display overrides.",
      "ui:description": "Override how the widget appears on specific pages. First matching pattern wins. To match query params or hashes, include ? or # explicitly in the pattern.",
      "maxItems": 100,
      "items": {
        "type": "object",
        "properties": {
          "pattern": {
            "type": "string",
            "ui:description": "URL pattern (glob)"
          },
          "display": {
            "type": "string",
            "enum": [
              "displayed",
              "hidden",
              "minimized"
            ],
            "ui:description": "Widget display mode for matching pages"
          }
        },
        "required": [
          "pattern",
          "display"
        ]
      }
    },
    "data_layer_display_conditions": {
      "type": "array",
      "x-tier": "advanced",
      "ui:sectionTitle": "Data Layer Targeting",
      "ui:sectionDescription": "Show the widget only when values already present on the page match.",
      "ui:sectionIcon": "Filter",
      "ui:title": "Data Layer Display Conditions",
      "ui:tooltip": "Show the widget only when host-page dataLayer values match.",
      "ui:description": "Advanced: require values already present in window.dataLayer before Rose displays. All conditions must match. Backoffice syntax: Key is a dataLayer field name or dot path such as countryCode or pagePostTerms.language. Values is the list of allowed scalar values, one value per row, such as FR or EN.",
      "maxItems": 20,
      "items": {
        "type": "object",
        "properties": {
          "key": {
            "type": "string",
            "ui:description": "Enter the dataLayer field to read. Use a plain key for top-level values, for example countryCode. Use dot notation for nested values, for example pagePostTerms.language.",
            "minLength": 1,
            "maxLength": 120
          },
          "values": {
            "type": "array",
            "ui:description": "Enter allowed values, one per row. If the dataLayer value is a string, it must equal one of these values. If the dataLayer value is an array, any item in the array can match one of these values.",
            "minItems": 1,
            "maxItems": 50,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 200
            }
          }
        },
        "required": [
          "key",
          "values"
        ]
      }
    },
    "spa_widget_handling": {
      "type": "object",
      "ui:description": "Some websites rebuild the page when visitors navigate instead of doing a full reload. This can destroy the widget. Enable this so the widget automatically re-appears after navigation.",
      "x-access": "staff",
      "properties": {
        "enabled": {
          "type": "boolean",
          "ui:description": "Re-mount the widget automatically after client-side navigation."
        },
        "url_patterns": {
          "type": "array",
          "ui:description": "Only apply on these URLs. Leave empty to apply everywhere.",
          "maxItems": 100,
          "items": {
            "type": "string"
          }
        }
      }
    },
    "conversation_per_workspace": {
      "type": "boolean",
      "x-access": "staff",
      "ui:title": "One conversation per workspace",
      "ui:description": "Only matters when several workspaces share one website (for example acme.com/fr and acme.com/de). On: a visitor moving to another workspace starts that workspace's own conversation. Off: the visitor keeps the same conversation across all workspaces of the website."
    }
  },
  "default": {
    "traffic_percentage": 100,
    "widget_display_mode": "normal",
    "enable_mobile": false,
    "mobile_breakpoint": 768,
    "page_display_rules": [],
    "display_only_on_urls": [],
    "data_layer_display_conditions": [],
    "spa_widget_handling": {
      "enabled": false,
      "url_patterns": []
    },
    "conversation_per_workspace": true
  }
}
